"use strict";
/// <reference path="./Templates.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.Templates = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
const $ = require("jquery");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const Utilities_1 = require("../../javascript/Utilities");
const Instance_1 = require("../../model/Instance");
let templateMarkup = require("./templates.tmpl.html");
class Templates {
    static init($elem, options) {
        return $elem.each(function () {
            const $this = $(this);
            const synData = $this.data('synTemplates');
            if (!synData) {
                $this.data('synTemplates', $.extend({
                    categoryTemplatesWSUrl: Utilities_1.synUtil.getWSUrl("CategoryTemplates"),
                    enabled: true,
                    ignoreDefaultTemplate: false
                }, options));
                $this.trigger("beginInit");
                const synData = $this.data("synTemplates");
                $this.addClass("synTemplates");
                let guid = Utilities_1.synUtil.getGUID(true);
                let proddefName1 = Utilities_1.synUtil.Strings.getValue("ceproddef.name.1");
                let menushowTemplates = Utilities_1.synUtil.Strings.getValue("menushowtemplates");
                let tmplData = {
                    prodSysName: proddefName1 || 'ceproddef.name.1',
                    templates: menushowTemplates || 'menushowtemplates',
                    prodSysDropDown: "prodSysDropDown_" + guid,
                    templateDropDown: "templateDropDown_" + guid
                };
                let template = kendo.template(templateMarkup);
                $this.html(template(tmplData));
                synData.templateDropDown =
                    $("#" + tmplData.templateDropDown).kendoDropDownList({
                        autoBind: false,
                        dataTextField: "name",
                        dataValueField: "id",
                        dataSource: new kendo.data.DataSource({
                            transport: {
                                read(options) {
                                    let requestOptions = {
                                        catId: synData.category
                                    };
                                    let selProdSys = synData.prodSysDropDown.dataItem(synData.prodSysDropDown.select());
                                    if (selProdSys && selProdSys.id)
                                        requestOptions.prodId = selProdSys.id;
                                    Utilities_1.synUtil.getAJAXData({
                                        method: "POST",
                                        url: synData.categoryTemplatesWSUrl,
                                        requestData: requestOptions,
                                        done(dataJSON) {
                                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                let instances = yield Instance_1.Instance.fromJSONArray(dataJSON);
                                                let templates = [];
                                                for (let instance of instances) {
                                                    templates.push({
                                                        id: instance.id.valueToString(),
                                                        name: instance.name.valueToString(),
                                                        prodid: instance.items["cedoctemplate.prodid"].valueToString(),
                                                        defval: instance.items["cedoctemplate.defcon"].valueAsBoolean
                                                    });
                                                }
                                                templates.sort(function (a, b) { return ((a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : ((a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : 0)); });
                                                if (templates.length)
                                                    templates.splice(0, 0, { id: "", name: "", prodid: "", defval: false });
                                                options.success(templates);
                                                $this.trigger("templatesReceived");
                                                synData.templateDropDown.enable(synData.enabled && templates.length > 0);
                                                if (synData.bDefCon && !synData.ignoreDefaultTemplate) {
                                                    synData.bDefCon = false;
                                                    synData.templateDropDown.select(function (dataItem) {
                                                        return dataItem.defval === true;
                                                    });
                                                    synData.templateDropDown.trigger('change');
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        }),
                        change(e) {
                            let sel = synData.templateDropDown.dataItem(synData.templateDropDown.select());
                            if (sel) {
                                if (sel.id) {
                                    $this.trigger("templateSelected", [{ id: sel.id, name: sel.name, prodid: sel.prodid }]);
                                }
                                else
                                    $this.trigger("templateUnselected");
                                synData.prodSysDropDown.dataSource.read();
                            }
                        }
                    }).data("kendoDropDownList");
                synData.prodSysDropDown =
                    $("#" + tmplData.prodSysDropDown).kendoDropDownList({
                        autoBind: false,
                        dataTextField: "name",
                        dataValueField: "id",
                        dataSource: new kendo.data.DataSource({
                            transport: {
                                read(options) {
                                    let requestOptions = {
                                        catId: synData.category
                                    };
                                    let selTempl = synData.templateDropDown.dataItem(synData.templateDropDown.select());
                                    Utilities_1.synUtil.getAJAXData({
                                        method: "POST",
                                        url: synData.categoryTemplatesWSUrl,
                                        requestData: requestOptions,
                                        done(dataJSON) {
                                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                let instances = yield Instance_1.Instance.fromJSONArray(dataJSON);
                                                let templates = [];
                                                let addedProdSys = {};
                                                let addedEmpty = false;
                                                for (let instance of instances) {
                                                    let templProdid = instance.items["cedoctemplate.prodid"].valueToString();
                                                    templProdid = (templProdid == undefined ? "0" : templProdid.toString());
                                                    if ((selTempl == undefined) || !selTempl.prodid || (selTempl.prodid.toString() === templProdid.toString())) {
                                                        if (!addedProdSys[templProdid]) {
                                                            templates.push({
                                                                id: templProdid,
                                                                name: instance.items["ceproddef.name"].value || "",
                                                                prodid: templProdid
                                                            });
                                                            addedProdSys[templProdid] = true;
                                                            if (templProdid === "0")
                                                                addedEmpty = true;
                                                        }
                                                    }
                                                }
                                                templates.sort(function (a, b) { return ((a.name < b.name) ? -1 : ((a.name > b.name) ? 1 : 0)); });
                                                if (templates.length && !addedEmpty)
                                                    templates.splice(0, 0, { id: "0", name: "" });
                                                options.success(templates);
                                                synData.prodSysDropDown.enable(synData.enabled && templates.length > 0);
                                                synData.templateDropDown.enable(synData.enabled && templates.length > 0);
                                                if (selTempl && selTempl.id) {
                                                    if (template.length !== 1) {
                                                        // Error
                                                        $.error('More than one ProdSys is not allowed');
                                                    }
                                                    else {
                                                        synData.prodSysDropDown.select(1);
                                                        synData.prodSysDropDown.trigger('change');
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        }),
                        change(e) {
                            synData.templateDropDown.dataSource.read();
                        }
                    }).data("kendoDropDownList");
                // Initially disable: Category has to be selected beforehand
                synData.templateDropDown.enable(false);
                synData.prodSysDropDown.enable(false);
                $this.trigger("initSuccess");
                $this.trigger("endInit");
            }
        });
    }
    static destroy($elem) {
        return $elem.each(() => {
            const $this = $(this);
            $(this).off("beginInit");
            $(this).off("initSuccess");
            $(this).off("endInit");
            $this.html("");
            $this.removeData('synTemplates');
        });
    }
    static setCategory($elem, catId) {
        return $elem.each(() => {
            const synData = $elem.data("synTemplates");
            synData.category = catId;
            synData.bDefCon = true;
            synData.bSelChanged = true;
            synData.templateDropDown.select(0);
            synData.prodSysDropDown.select(0);
            synData.templateDropDown.dataSource.read();
            synData.prodSysDropDown.dataSource.read();
            synData.templateDropDown.enable(true);
            synData.prodSysDropDown.enable(true);
        });
    }
    static selectIndex($elem, index) {
        const synData = $elem.data("synTemplates");
        synData.templateDropDown.select(index);
        synData.prodSysDropDown.select(index);
    }
    static getSelectedTemplateId($elem) {
        const synData = $elem.data("synTemplates");
        let sel = synData.templateDropDown.dataItem(synData.templateDropDown.select());
        if (sel && sel.id)
            return sel.id;
        return undefined;
    }
    static setSelectedTemplateId($elem, id) {
        const synData = $elem.data("synTemplates");
        synData.templateDropDown.select(dataItem => dataItem.id === id);
        synData.templateDropDown.trigger("change");
    }
    static clearTemplateSelection($elem) {
        const synData = $elem.data("synTemplates");
        synData.templateDropDown.select(0);
        synData.templateDropDown.trigger("change");
    }
    static getTemplateCount($elem) {
        const synData = $elem.data("synTemplates");
        return synData.templateDropDown.dataSource.data().length;
    }
    static enable($elem, enabled) {
        return $elem.each(() => {
            const synData = $elem.data("synTemplates");
            synData.enabled = enabled;
            synData.templateDropDown.enable(enabled);
            synData.prodSysDropDown.enable(enabled);
        });
    }
}
exports.Templates = Templates;
// Dispatcher code
(($) => {
    $.fn.synTemplates = function (method) {
        if (Templates[method])
            return Templates[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === "object" || !method)
            return Templates.init(this, arguments[0]);
        else
            $.error("Method " + method + " does not exist on jQuery.synTemplates");
    };
})(jQuery);
